<template>
    <div>
        <router-link v-if="(isGoal || isUser) && !isArtifactDeleted" :to="postTitleLink">
            {{ postTitle }}
        </router-link>
        <div v-else-if="isOKRCheckin || isKeyResult">
            <b-link
                v-if="!isArtifactDeleted"
                :href="goToKeyResultPage(post.key_result.objective_id, post.key_result.id)"
            >
                {{ post.key_result.title }}
            </b-link>
            <span v-else>{{ post.key_result.title }}</span>
            <div class="text-muted mb-1">
                <small>
                    <em class="fa fa-calendar mr-1"></em>
                    <span class="field">em: {{ this.createdAt }}</span>
                </small>
            </div>
        </div>
        <b-link v-else-if="isObjective && !isArtifactDeleted" :href="goToObjectivePage(post.objective_id)">
            {{ postTitle }}
            <div class="text-muted mb-1">
                <small>
                    <em class="fa fa-calendar mr-1"></em>
                    <span class="field">em: {{ this.createdAt }}</span>
                </small>
            </div>
        </b-link>
        <span v-else-if="!isNetwork && !isPDI">
            {{ postTitle }}
        </span>
        <div v-else-if="isPDI">
            <span>{{ post.action_plan.title }}</span>
            <div class="text-muted mb-1">
                <small>
                    <em class="fa fa-calendar mr-1"></em>
                    <span class="field">em: {{ this.createdAt }}</span>
                </small>
            </div>
        </div>
    </div>
</template>

<script>
import { goToOKRPageMixin, artifactTypeMixin } from '@/mixins'
import moment from 'moment'

export default {
    name: 'PostTitle',
    mixins: [goToOKRPageMixin, artifactTypeMixin],
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    computed: {
        postTitleLink() {
            if (this.isGoal) {
                return `/v2/target/targets/view/${this.post.artifact.id}`
            }
            if (this.isUser && this.post.artifact) {
                return `/v2/profile/${this.post.artifact.id}`
            }
        },
        postTitle() {
            if (this.isUser && this.post.artifact) {
                return this.post.artifact.name
            }
            return this.post.artifact.title
        },
        createdAt() {
            return moment(this.post.created_at).format('DD/MM/YYYY HH:mm:ss')
        },
    },
}
</script>

<style></style>
